import React, { useState, useEffect } from 'react';
import {
  format, addMonths, subMonths, startOfMonth, endOfMonth, parseISO, isAfter,
} from 'date-fns';
import pt from 'date-fns/locale/pt';
import { useSelector } from 'react-redux';

import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { toast } from 'react-toastify';
import history from '~/services/history';

import api from '~/services/api';
import { Container, List3 } from '~/pages/_layouts/default/styles';

function Sales() {
  const [schedule, setSchedule] = useState([]);
  const profile = useSelector((state) => state.user.profile);
  const [month, setMonth] = useState(new Date());
  const [showright, setShowright] = useState(false);
  const [show_date, setShow_date] = useState(true);

  useEffect(() => {
    async function loadSales() {
      try {
        setShow_date(true);
        const date1 = startOfMonth(month);
        const date2 = endOfMonth(month);
        const response = await api.get('inventario', {
          params: {
            date1, date2, active: true, ordercreate: 'DESC',
          },
        });
        setSchedule(response.data);
      } catch (err) {
        if (err.response) {
          toast.error(err.response.data.error);
          if (err.response.data.error === 'Token invalid') { history.push('/signout'); }
        } else { toast.error('Falha ao carregar vendas'); }
      }
    }
    loadSales();
  }, [month, profile.company]);

  function handlePrevMonth() {
    setMonth(subMonths(month, 1));
    if (isAfter(new Date(), subMonths(month, 2))) {
      setShowright(true);
    } else {
      setShowright(false);
    }
  }
  function handleNextMonth() {
    setMonth(addMonths(month, 1));
    if (isAfter(new Date(), addMonths(month, 2))) {
      setShowright(true);
    } else {
      setShowright(false);
    }
  }

  return (

    <Container>
      <header>

        {!show_date ? null
          : (
            <>
              <button type="button" onClick={handlePrevMonth}>
                <MdChevronLeft size={30} color="#ffff" />
              </button>
              <strong>{format(month, 'MMMM/YYY', { locale: pt })}</strong>
              { !showright ? null
                : (
                  <button type="button" onClick={handleNextMonth}>
                    <MdChevronRight size={30} color="#ffff" />
                  </button>
                )}
            </>
          )}

      </header>

      <></>

      <ul>
        { schedule.map((aa) => (
          <List3 key={String(aa.id)} noactive={!aa.active}>

            <span>
              {format(parseISO(aa.date), "dd'/'MM'-'HH:mm", { locale: pt })}
              {' '}
              {aa.name}
              {' '}
              {aa.pgto}
              {' '}
              {aa.note}
            </span>

            <aside3>
              <ul>
                <span>
                  {aa.qty}
                  {' '}
                </span>
              </ul>
            </aside3>

          </List3>
        ))}
      </ul>
      <ul />

    </Container>
  );
}

export default Sales;
